import { render, staticRenderFns } from "./medical_details.vue?vue&type=template&id=5376f97e"
import script from "./medical_details.vue?vue&type=script&lang=js"
export * from "./medical_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports